import WalkthroughTipPresenter from "frontend/walkthrough-tips/walkthrough-tip-presenter";
import { useRef } from "react";
import { TipName } from "shared/datamodel/schemas";
import { FooterButtonGroup, FooterButton } from "./footer";
import { getPathPrefix } from "../utils/getPathPrefix";

export function ToggleSideMenu({
  onChange,
  isSideMenuOpen,
  onPresentClicked,
}: {
  onChange: (open: boolean) => void;
  isSideMenuOpen: boolean;
  onPresentClicked: () => void;
}) {
  const presentRef = useRef<HTMLDivElement>(null);
  const sideMenuRef = useRef<HTMLDivElement>(null);
  return (
    <>
      <FooterButtonGroup>
        <FooterButton
          tooltip={isSideMenuOpen ? "Close sidebar" : "Open sidebar"}
          onClick={() => onChange(!isSideMenuOpen)}
          ref={sideMenuRef}
        >
          <img
            src={
              isSideMenuOpen
                ? getPathPrefix("/images/close-side-panel.svg")
                : getPathPrefix("/images/open-side-panel.svg")
            }
          />
        </FooterButton>
      </FooterButtonGroup>
      <FooterButtonGroup>
        <FooterButton tooltip="Present" onClick={onPresentClicked} ref={presentRef} testid="canvas-presentation-view">
          <img src={getPathPrefix("/images/present-canvas-icon.svg")} />
        </FooterButton>
      </FooterButtonGroup>
      <WalkthroughTipPresenter tipName={TipName.walkthroughPresentationMode} attachToRef={presentRef} />
    </>
  );
}
